<template>
  <mdb-container>
    <div class="gp-has-header" v-if="loggedIn && isTranslator">
      <h3>Translate Messaging</h3>
      <translate-section category="common" sub-category="messaging"/>
    </div>
  </mdb-container>
</template>

<script>

import TranslateSection from "../common/TranslateSection";
import Security from "../../services/security";

import {mdbContainer} from 'mdbvue';

export default {
  name: 'translate-menu-items',
  components: {
    mdbContainer,
    TranslateSection
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    isTranslator() {
      return Security.isTranslator()
    }
  },
  mounted() {
    document.title = "Menu Items"
  }
}
</script>

